import { DividerComp } from "./styles";

export default function DividerComponent() {
    return <DividerComp />;
}